var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2449 51.5102C17.2969 51.5102 5.9898 40.2031 5.9898 26.2551C5.9898 12.3071 17.2969 1 31.2449 1C45.1929 1 56.5 12.3071 56.5 26.2551C56.5 40.2031 45.1929 51.5102 31.2449 51.5102Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2449 51.5102C17.2969 51.5102 5.9898 40.2031 5.9898 26.2551C5.9898 12.3071 17.2969 1 31.2449 1C45.1929 1 56.5 12.3071 56.5 26.2551C56.5 40.2031 45.1929 51.5102 31.2449 51.5102Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7227 44.7734L1.49817 55.9979",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 14.4688V39.1626H41.9074",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9492 33.5529C23.9471 29.0851 24.4654 23.5659 28.1489 22.9527C31.8323 22.3394 32.3614 28.1296 36.5737 27.7546C40.786 27.3795 41 22.002 40.786 15.5938",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1557 18.235L40.8047 14.4688L37.4537 18.235",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.0facf512046fbed0c565b84ce891f4b6.svg";
export { ForwardRef as ReactComponent };